import TooltipButton from "views/Documents/components/TooltipButton";
import { MdDelete } from "react-icons/md";
import { useTranslation } from "react-i18next";
import useSales from "../../hooks/useSales";
import { Modal } from "antd";

interface RemoveButtonPropsTypes {
  id?: ID;
  refetch?: () => void;
}

export default function RemoveButton({ id, refetch }: RemoveButtonPropsTypes) {
  const { t } = useTranslation();
  const { deleteClientVatAccountingConfig } = useSales();

  const confirmDelete = (id: ID) => {
    Modal.confirm({
      title: t("Delete sale account"),
      content: t("Are you sure about delete this sale account?"),
      okText: t("Yes"),
      okType: "danger",
      onOk: () => handleOk(id),
    });
  };

  const handleOk = async (id: ID) => {
    await deleteClientVatAccountingConfig({
      variables: {
        id,
      },
    });

    refetch!();
  };

  return (
    <TooltipButton
      variant="delete"
      placement="top"
      handleOnClick={() => confirmDelete(id)}
      icon={<MdDelete />}
    />
  );
}
